export default "__VITE_ASSET__50fce5bd__"